import { useEffect, useCallback, RefObject } from "react";
import mapboxgl from "mapbox-gl";
import { mapControls } from "../config/mapConfig";

export const useMapControls = (
	map: RefObject<any | null>,
	mapInitialized: boolean
) => {
	const initializeControls = useCallback(() => {
		if (!map || !map.current || !mapInitialized) return;

		// Navigation control
		const nav = new mapboxgl.NavigationControl();
		map.current?.addControl(nav, mapControls.navigation.position);

		// Geolocate control
		const geolocate = new mapboxgl.GeolocateControl({
			...mapControls.geolocate.options,
		});

		map.current?.addControl(geolocate, mapControls.geolocate.position);

		return () => {
			map.current?.removeControl(nav);
			map.current?.removeControl(geolocate);
		};
	}, [map, mapInitialized]);

	const toggleControl = useCallback(
		(controlId: any, show: boolean) => {
			if (!map) return;

			const control = map.current?.hasControl(controlId);

			if (show && !control) {
				initializeControls();
			} else if (!show && control) {
				map.current?.removeControl(controlId);
			}
		},
		[map, initializeControls]
	);

	useEffect(() => {
		const cleanup = initializeControls();

		return () => {
			if (cleanup) cleanup();
		};
	}, [initializeControls]);

	return {
		toggleControl,
	};
};
